export const billingRecord = [
  {
    name: 'serviceName',
    label: 'Service',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'nbsUserId',
    label: 'User ID',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'transactionDate',
    label: 'Transaction Date',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'filerCode',
    label: 'Filer Code',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'refNo1',
    label: 'Ref No. 1',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'refNo2',
    label: 'Ref No. 2',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'refNo3',
    label: 'Ref No. 3',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'refNo4',
    label: 'Ref No. 4',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'messageType',
    label: 'Message Type',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'transactionId',
    label: 'Transaction ID',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
  {
    name: 'status',
    label: 'Status',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
];
